export default __webpack_public_path__ + "b4d04694a97846cf8078d5031262285f.woff2?proxy=wpt-abc";